'use client';
import { createPortal } from 'react-dom';

// src/components/portal/index.tsx
var Portal = ({
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  container = globalThis?.document?.body,
  children
}) => {
  return container ? createPortal(children, container) : null;
};
Portal.displayName = "Portal";
var portal_default = Portal;

export { portal_default as default };
